import React from "react";
import { Route, Redirect } from "react-router-dom";
import { Content } from "./Content";
import { useSelector } from "react-redux";

export function ContentRoute({ children, component, render, ...props }) {
  const user = useSelector((state) => state.user.user);

  return (
    <Route {...props}>
      {(routeProps) => {
        // Check role only when role is provided
        if (props.role) {
          if (Array.isArray(props.role)) {
            if (!props.role.includes(user?.roles?.[0]?.name)) {
              return (
                <Redirect
                  to={{
                    pathname: "/error/error-v1",
                    state: {
                      from: props.location,
                    },
                  }}
                />
              );
            }
          } else {
            if (props.role !== user?.roles?.[0]?.name) {
              return (
                <Redirect
                  to={{
                    pathname: "/error/error-v1",
                    state: {
                      from: props.location,
                    },
                  }}
                />
              );
            }
          }
        }

        // Route does not match
        if (!routeProps.match) {
          return null;
        }

        // Children function
        if (typeof children === "function") {
          return <Content>{children(routeProps)}</Content>;
        }

        // Children element
        if (children) {
          return <Content>{children}</Content>;
        }

        // Component
        if (component) {
          return (
            <Content>
              {React.createElement(component, routeProps)}
            </Content>
          );
        }

        // Render prop
        if (render) {
          return <Content>{render(routeProps)}</Content>;
        }

        return null;
      }}
    </Route>
  );
}